import { MQ_SMALL_ONLY, MQ_MIDLARGE, MQ_LARGE, MQ_MEDIUM } from 'constants/mq';
import IMAGE_SIZES from 'constants/imageSizes';

const { base3x2, large4x5, medium3x2, medium4x5, small4x5 } = IMAGE_SIZES;

const base = {
  fallbackDims: base3x2,
  sourceSets: [
    {
      layoutWidth: { value: 367, units: 'px' },
      imageDims: large4x5,
      media: MQ_MIDLARGE
    },
    {
      layoutWidth: { value: 310, units: 'px' },
      imageDims: medium4x5,
      media: MQ_LARGE
    },
    {
      layoutWidth: { value: 224, units: 'px' },
      imageDims: small4x5,
      media: MQ_MEDIUM
    },
    {
      layoutWidth: { value: 320, units: 'px' },
      imageDims: medium3x2,
      media: MQ_SMALL_ONLY
    }
  ],
  placeholders: [
    {
      media: MQ_MEDIUM,
      ratio: 4 / 5
    },
    {
      media: MQ_SMALL_ONLY,
      ratio: 3 / 2
    }
  ]
};

const exceptionPatterns = undefined;

export default {
  base,
  exceptionPatterns
};
